import { render } from "./MutualLogo.vue?vue&type=template&id=04e79a8f&scoped=true"
import script from "./MutualLogo.vue?vue&type=script&lang=js"
export * from "./MutualLogo.vue?vue&type=script&lang=js"

import "./MutualLogo.vue?vue&type=style&index=0&id=04e79a8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e79a8f"],['__file',"src/components/MutualLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04e79a8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04e79a8f', __exports__)) {
    api.reload('04e79a8f', __exports__)
  }
  
  module.hot.accept("./MutualLogo.vue?vue&type=template&id=04e79a8f&scoped=true", () => {
    api.rerender('04e79a8f', render)
  })

}


export default __exports__